import recoveryActionMap from './recoveryActionMap';

export default function getAvailableRecoveryActions(): string[] {
    return Array.from(recoveryActionMap.keys());
}
